import { createApp } from 'vue'

import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/index.scss';

import httpInterceptor from "@/_helpers/http-interceptor";
httpInterceptor();

import App from './App.vue';
import router from './router';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import {
  faUserSecret,
  faPenToSquare,
  faPenRuler,
  faLeftLong,
  faCheck,
  faTriangleExclamation,
  faFolder,
  faCircleExclamation,
  faArrowUpRightFromSquare,
  faFlag,
  faExplosion,
  faPlay
} from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(
  faUserSecret,
  faPenToSquare,
  faPenRuler,
  faLeftLong,
  faCheck,
  faTriangleExclamation,
  faFolder,
  faCircleExclamation,
  faArrowUpRightFromSquare,
  faFlag,
  faExplosion,
  faPlay
)

import VueClipboard from 'vue3-clipboard';
// import mixpanel from 'mixpanel-browser';
// mixpanel.init('d00f2cc4e4a8af7aafe864ba6317721f', { debug: true, track_pageview: true, persistence: 'localStorage' });

// // Track an event. It can be anything, but in this example, we're tracking a Sign Up event.
// mixpanel.track('Purchase', {
//   'Signup Type': 'Referral'
// })

const app = createApp(App).use(router).use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
}).component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app')

import "bootstrap/dist/js/bootstrap"
